import { render, staticRenderFns } from "./TableResponsivePage.vue?vue&type=template&id=6c63985e&scoped=true&"
import script from "./TableResponsivePage.vue?vue&type=script&lang=js&"
export * from "./TableResponsivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63985e",
  null
  
)

export default component.exports